import update from "immutability-helper";
import { POSReduxActions } from "./Action";

export interface ICartProduct {
  id: string;
  name: string;
  description: string;
  price: number;
  customerPrice: number;
  discountPercent: number;
  saleUserId: string;
  rate: number;
  quantity: number;
  discountAmount: number;
  itemTotal: number;
  itemPayable: number;
  qrCode: string;
}

export interface IBill {
  billId: string;
  invoiceId: string;
  customerName: string;
  customerMobile: string;
  customerAddress: string;
  billNote: string;
  products: ICartProduct[];
  cashReceived: number;
  paymentMode: "Cash" | "UPI" | "Finance";
}

export interface IPOSState {
  bills: IBill[];
  activeBillIndex: number;
}

export const NewBill: IBill = {
  billId: "",
  invoiceId: "",
  customerName: "",
  customerMobile: "",
  customerAddress: "",
  billNote: "",
  products: [],
  cashReceived: 0,
  paymentMode: "Cash",
};

const posState: IPOSState = {
  bills: [{ ...NewBill, products: [] }],
  activeBillIndex: 0,
};

const POSStateReducer = (
  state = posState,
  action: any = { type: "", payload: {} }
): IPOSState => {
  switch (action.type) {
    case POSReduxActions.SET_BILLINGS:
      return update(state, {
        $merge: {
          bills: action.payload,
        },
      });
    case POSReduxActions.SET_ACTIVE_BILL:
      return update(state, {
        $merge: {
          activeBillIndex: action.payload,
        },
      });
    default:
      return state;
  }
};

export default POSStateReducer;
